import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const BoldAboutSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section id="about" className="py-32 px-6 relative">
      {/* Section Watermark */}
      <div className="section-watermark" style={{ top: '5%', left: '-5%' }}>01</div>
      
      <div className="max-w-7xl mx-auto" ref={ref}>
        {/* Heading */}
        <motion.h2
          className="text-center mb-20 gradient-text"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.6, 0.01, 0.05, 0.95] }}
          style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}
        >
          More than marketing —<br />measurable growth
        </motion.h2>
        
        {/* Asymmetric Two-Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left: Oversized Pull Quote */}
          <motion.div
            className="lg:col-span-3"
            initial={{ opacity: 0, x: -60 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#EDE9FE] leading-tight" style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}>
              I don't just run campaigns —{' '}
              <span className="gradient-text">I build the systems</span>{' '}
              behind them.
            </p>
            <p className="text-xl text-[#9D97B5] mt-8 leading-relaxed">
              From search visibility to paid social to the website itself, I connect every part of the funnel around one goal: turning visitors into customers. Strategy, execution, and the technical setup to back it — handled by one person who sees the whole picture.
            </p>
          </motion.div>
          
          {/* Right: Stacked Tag Cards */}
          <motion.div
            className="lg:col-span-2 space-y-6"
            initial={{ opacity: 0, x: 60 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <motion.div
              className="p-8 bg-[#1A1430] border-2 border-[#7C3AED]/30 rounded-3xl hover:border-[#FF5C39] transition-all duration-300"
              whileHover={{ scale: 1.03, y: -5 }}
            >
              <p className="text-sm text-[#9D97B5] mb-2">Leads with</p>
              <p className="text-2xl font-bold gradient-text" style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}>Digital Marketing</p>
            </motion.div>
            
            <motion.div
              className="p-8 bg-[#1A1430] border-2 border-[#7C3AED]/30 rounded-3xl hover:border-[#FF5C39] transition-all duration-300"
              whileHover={{ scale: 1.03, y: -5 }}
            >
              <p className="text-sm text-[#9D97B5] mb-2">Pairs with</p>
              <p className="text-2xl font-bold gradient-text" style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}>Social Media Management</p>
            </motion.div>
            
            <motion.div
              className="p-8 bg-[#1A1430] border-2 border-[#7C3AED]/30 rounded-3xl hover:border-[#FF5C39] transition-all duration-300"
              whileHover={{ scale: 1.03, y: -5 }}
            >
              <p className="text-sm text-[#9D97B5] mb-2">Backed by</p>
              <p className="text-2xl font-bold gradient-text" style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}>Web Development</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BoldAboutSection;